import React, { Component } from 'react';
import { connect } from 'react-redux';
import ForgotPassword from '../../components/ForgotPassword/ForgotPassword';
import LoginClass from '../../shared/loginClass/LoginClass';
import { forgotPassword } from '../../store/actions/userActions';
import { ToastContainer, toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';

class ForgotPasswordContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
          isLoggingOut: false,
        };
        this.cognitoAuth = new LoginClass();
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.forgotPassStatus && nextProps.forgotPassStatus.name === 'InvalidParameterException') {
        toast.error(nextProps.forgotPassStatus.message);
        return;
      }
      if (nextProps.forgotPassStatus && nextProps.forgotPassStatus.code === 'UserNotFoundException') {
        toast.error(nextProps.forgotPassStatus.message);
        return;
      }
      
      if (nextProps.forgotPassStatus && nextProps.forgotPassStatus.status === 200) {
        toast.success(nextProps.forgotPassStatus.message);
        return;
      }
    }

    onForgotPassword = (email) => {
      this.props.dispatch(forgotPassword(email));
    }

    render() {
      return (
        <div>
          <ToastContainer
            position="top-right"
            type="success"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            pauseOnHover
          />
          <ForgotPassword
            onForgotPassword={this.onForgotPassword}
            forgotPassPending={this.props.forgotPassPending}
            forgotPassStatus={this.props.forgotPassStatus}
            loading={this.props.loading}
            forgotPasswordPending={this.props.forgotPasswordPending}
          />
        </div>
      );
    }
}

// function loadStyleSheet(url) {
//     let main = document.getElementById('main-style');
//     main.href = url;
// }

function MapStateToProps(state, ownProps) {
  return {
    forgotPassPending: state.user.forgotPasswordPending,
    forgotPasswordPending: state.user.forgotPasswordPending,
    forgotPassStatus: state.user.forgotPassword,
    forgotPasswordConfirmStatus: state.user.forgotPasswordVerify,
    loading: state.user.loading
  };
}

export default withRouter(connect(MapStateToProps)(ForgotPasswordContainer));



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword/ForgotPasswordContainer.js